import React, { useEffect, useState } from "react";
// import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Head from "next/head";
import striptags from "striptags";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Link from "next/link";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import Image from "next/image";

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));
const CommonCtaSection = dynamic(() =>
  import("../../components/common/CTASection/CommonCtaSection")
);

const CaseStudiesDetails = ({ apiData }) => {
  const commonCtaData = apiData?.body?.find((block) => block?.type === "cta");
  const [loader, setLoader] = useState(true);
  const [caseDetail, setCaseDetail] = useState();
  const [active, setActive] = useState();
  const [projectId, setProjectId] = useState(0);
  const [socialIcon, setSocialIcon] = useState();

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const canonicalUrl = apiData?.canonical_url;
  const search_description = apiData?.meta?.search_description;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }
  useEffect(() => {
    const response = apiData;
    response && setCaseDetail(response);

    if (footerData) {
      setLoader(false);
      const filterData = footerData?.common_images?.filter((item) => {
        return item?.title == "Social Media Icon List";
      });
      filterData && setSocialIcon(filterData);
    }
  }, [footerData]);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <main className="main-wrapper case-studies-middle wrapper-top-bg">
          <article className="wrapper-inner">
            <section
              className="caseStudiesdet-hero-section light-primary-background"
              style={{ background: "#e1f2f9" }}
            >
              <div className="caseStudiesdet-hero-inner">
                <div className="container">
                  <div className="row caseStudiesdet-hero-row">
                    <div className="col-lg-7 col-md-7">
                      <div className="caseStudiesdet-hero-content">
                        {caseDetail?.banner?.map((val, i) => {
                          if (val?.type == "heading") {
                            const titleWithoutPTag = striptags(
                              val?.value,
                              "<span>"
                            );
                            return (
                              <div
                                className="caseStudiesdet-heading heading"
                                key={i}
                              >
                                <span
                                  className="heading-h1"
                                  itemProp="heading"
                                  dangerouslySetInnerHTML={{
                                    __html: titleWithoutPTag,
                                  }}
                                ></span>
                              </div>
                            );
                          }
                        })}
                        {caseDetail?.banner?.map((val, i) => {
                          if (val?.type == "about") {
                            return (
                              <div className="caseStudies-sub-heading" key={i}>
                                <h2
                                  dangerouslySetInnerHTML={{
                                    __html: val?.value?.title,
                                  }}
                                ></h2>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: val?.value?.description,
                                  }}
                                ></p>
                              </div>
                            );
                          }
                        })}

                        <div className="caseStudiesdet-tag">
                          <div className="row">
                            <div className="col-xxl-4 col-xl-5 col-md-6 col-sm-5 col-6">
                              <div className="caseStudiesdet-tag-card">
                                <p className="caseStudiesdet-tag-title">
                                  Industry
                                </p>
                                <p className="caseStudiesdet-tag-info">
                                  {caseDetail?.industry}
                                </p>
                              </div>
                            </div>
                            {caseDetail?.banner?.map((val, i) => {
                              if (val?.type == "tags") {
                                return (
                                  <div
                                    key={i}
                                    className="col-xxl-4 col-xl-5 col-md-6 col-sm-5 col-6"
                                  >
                                    <div className="caseStudiesdet-tag-card">
                                      <p
                                        className="caseStudiesdet-tag-title"
                                        dangerouslySetInnerHTML={{
                                          __html: val?.value[0]?.value?.title,
                                        }}
                                      ></p>
                                      <p
                                        className="caseStudiesdet-tag-info"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            val?.value[0]?.value?.description,
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    {caseDetail?.banner?.map((val, i) => {
                      return (
                        <React.Fragment key={i}>
                          {val?.type == "image" && (
                            <div className="col-lg-5 col-md-5 col-hero-end">
                              <div className="caseStudiesdet-hero-img">
                                <Image
                                  height={500}
                                  width={500}
                                  src={val?.value?.url}
                                  alt={val?.value?.alt_text ?? 'Digitally Transforming'}
                                  loading="eager"
                                />
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>
            <section
              className="caseStudies-details-section"
              style={{ background: "#f6fbfd" }}
            >
              <div className="caseStudies-details-inner">
                <div className="container">
                  <div className="row caseStudies-details-row">
                    <div className="col-lg-8 col-md-7">
                      <div className="caseStudies-details-wrapper">
                        <div className="row">
                          <div className="col-lg-1 col-md-1 social-md-none">
                            <div className="caseStudies-social-media">
                              <ul className="caseStudies-social-list">
                                {socialIcon &&
                                  socialIcon[0]?.images?.map(
                                    (val, innerIndex, array) => {
                                      const urlHtml = val?.value?.url;
                                      const hrefMatch = /href="([^"]+)"/.exec(
                                        urlHtml
                                      );
                                      const href = hrefMatch
                                        ? hrefMatch[1]
                                        : "";

                                      const redirectToCurrentBlog = (
                                        e,
                                        socialNetwork
                                      ) => {
                                        e.preventDefault();
                                        const currentPageURL =
                                          window.location.href;
                                        let shareURL = "";

                                        switch (socialNetwork) {
                                          case "facebook":
                                            shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                                              currentPageURL
                                            )}`;
                                            break;
                                          case "twitter":
                                            shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                                              currentPageURL
                                            )}`;
                                            break;
                                          case "linkedin":
                                            shareURL = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
                                              currentPageURL
                                            )}`;
                                            break;
                                          // Add more cases for other social networks if needed

                                          default:
                                            break;
                                        }

                                        window.location = shareURL;
                                      };

                                      const copyCurrentPageURL = (e) => {
                                        e.preventDefault();
                                        const currentPageURL =
                                          window.location.href;
                                        const textArea =
                                          document.createElement("textarea");
                                        textArea.value = currentPageURL;
                                        document.body.appendChild(textArea);
                                        textArea.select();
                                        document.execCommand("copy");
                                        document.body.removeChild(textArea);
                                      };
                                      return (
                                        <li key={innerIndex}>
                                          <Link
                                            href={href}
                                            onClick={(e) => {
                                              if (
                                                innerIndex ===
                                                array.length - 1
                                              ) {
                                                copyCurrentPageURL(e);
                                              } else {
                                                redirectToCurrentBlog(
                                                  e,
                                                  val?.value?.title
                                                );
                                              }
                                            }}
                                          >
                                            <Image
                                              height={100}
                                              width={100}
                                              src={val?.value?.url}
                                              alt={val?.value?.alt_text ?? 'Digitally Transforming'}
                                              loading="eager"
                                            />
                                          </Link>
                                        </li>
                                      );
                                    }
                                  )}
                              </ul>
                            </div>
                          </div>

                          <div className="col-md-12 col-lg-11">
                            <div className="caseStudies-content-wrapper">
                              {caseDetail?.overview?.map((val, i) => {
                                if (val?.type == "project") {
                                  return (
                                    <div
                                      className="caseStudies-project-overview"
                                      id="0"
                                      key={i}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: val?.value?.title,
                                        }}
                                      ></div>

                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: val?.value?.description,
                                        }}
                                      ></div>
                                    </div>
                                  );
                                }
                              })}

                              <div
                                className="caseStudies-major-challenges"
                                id="major-challenges"
                              >
                                {caseDetail?.body?.map((val, i) => {
                                  if (val?.type == "challenges") {
                                    return (
                                      <React.Fragment key={i}>
                                        <h2
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.title,
                                          }}
                                        ></h2>
                                        <ul
                                          className="major-challenges-list"
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.description,
                                          }}
                                        ></ul>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                              <div className="caseStudies-our-solutions" id="1">
                                {caseDetail?.body?.map((val, i) => {
                                  if (val?.type == "solution") {
                                    return (
                                      <React.Fragment key={i}>
                                        <h2
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.title,
                                          }}
                                        ></h2>
                                        <ul
                                          className="our-solutions-list"
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.description,
                                          }}
                                        ></ul>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                              <div className="caseStudies-main-features" id="2">
                                {caseDetail?.body?.map((val, index) => {
                                  if (val?.type == "features") {
                                    return (
                                      <React.Fragment key={index}>
                                        <h2
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.title,
                                          }}
                                        ></h2>
                                        <ul
                                          className="main-features-list"
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.description,
                                          }}
                                        ></ul>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                              <div
                                className="caseStudies-technology-stack"
                                id="3"
                              >
                                {caseDetail?.body?.map((val, index) => {
                                  if (val?.type == "technology_stack") {
                                    return (
                                      <React.Fragment key={index}>
                                        <h2
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.title,
                                          }}
                                        ></h2>
                                        <ul className="caseStudies-technology-list">
                                          {val?.value?.list?.map((val, i) => {
                                            return (
                                              <li key={`${i}_j`}>
                                                <div className="row">
                                                  <div className="col-lg-4">
                                                    <div className="caseStudies-tecsta-title">
                                                      <span>
                                                        {val?.value?.title}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-8">
                                                    <div className="caseStudies-tecsta-div">
                                                      {val?.value?.images?.map(
                                                        (val, ind) => {
                                                          return (
                                                            <div
                                                              className="caseStudies-tecsta-box"
                                                              key={`${ind}_j`}
                                                            >
                                                              <div className="caseStudies-tecsta-icon">
                                                                <Image
                                                                  height={300}
                                                                  width={300}
                                                                  src={val?.url}
                                                                  alt={val?.alt_text ?? 'html'}
                                                                  loading="eager"
                                                                />
                                                              </div>
                                                              <div className="caseStudies-tecsta-caption">
                                                                <p>
                                                                  {val?.title}
                                                                </p>
                                                              </div>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                              <div className="caseStudies-stake-holder" id="4">
                                {caseDetail?.body?.map((val, index) => {
                                  if (val?.type == "stake_holder") {
                                    return (
                                      <React.Fragment key={index}>
                                        <h2
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.title,
                                          }}
                                        ></h2>
                                        <div
                                          className=""
                                          dangerouslySetInnerHTML={{
                                            __html: val?.value?.description,
                                          }}
                                        ></div>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                      <div className="caseStudies-details-right">
                        <div className="caseStudies-right-tab">
                          <ul className="caseStudies-details-tab">
                            {caseDetail?.overview?.map((val, index) => {
                              if (val?.type == "project") {
                                return (
                                  <li key={index}>
                                    <AnchorLink
                                      offset={() => 120}
                                      href={`#${index}`}
                                      className={`case-study-link tab-link ${projectId == index ? "active" : ""
                                        }`}
                                      // dangerouslySetInnerHTML={{
                                      //   __html: val?.value?.title,
                                      // }}
                                      onClick={() => {
                                        setProjectId(index);
                                        setActive(null);
                                      }}
                                    >
                                      {striptags(val?.value?.title)}
                                    </AnchorLink>
                                  </li>
                                );
                              }
                            })}
                            {caseDetail?.body?.slice(1)?.map((val, index) => {
                              return (
                                <li key={index}>
                                  <AnchorLink
                                    href={`#${index}`}
                                    className={`case-study-link tab-link ${active == index ? "active" : ""
                                      }`}
                                    // dangerouslySetInnerHTML={{
                                    //   __html: val?.value?.title,
                                    // }}
                                    onClick={() => {
                                      setActive(index);
                                      setProjectId(null);
                                    }}
                                  >
                                    {striptags(val?.value?.title)}
                                  </AnchorLink>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div className="caseStudies-social-media social-lg-none">
                          {caseDetail?.body?.map((val, ind) => {
                            if (val?.type == "link_sharing") {
                              return (
                                <ul
                                  className="caseStudies-social-list"
                                  key={ind}
                                >
                                  {val?.value?.map((val, i) => {
                                    const urlHtml = val?.value?.url;
                                    const hrefMatch = /href="([^"]+)"/.exec(
                                      urlHtml
                                    );
                                    const href = hrefMatch ? hrefMatch[1] : "";
                                    return (
                                      <li key={`${i}_u`}>
                                        <Link href={href}>
                                          <Image
                                            src={
                                              val?.value?.images[0]?.value?.url
                                            }
                                            alt={val?.value?.images[0]?.value?.alt_text ?? 'html'}
                                            height={100}
                                            width={100}
                                            loading="eager"
                                          />
                                        </Link>
                                      </li>
                                    );
                                  })}
                                </ul>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <CommonCtaSection data={commonCtaData} />
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps(context) {
  const { query } = context;
  const yourValue = query.slug;

  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + `/cms/pages/${yourValue}`,
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  if (apiData?.redirect_url) {
    return {
      redirect: {
        destination: apiData.redirect_url,
        permanent: false,
      },
    };
  }

  return {
    props: {
      apiData,
    },
  };
}

export default CaseStudiesDetails;
